import { useMutation, useQueryClient } from "react-query";
import { API_URL } from "../api";
import { APIError, APIResponse, post } from "../api";

export type ClaimRewardResult = {
  grantId: string;
  kind: string;
  phone: string;
  reference: string;
};

/** Redeems a CLAIMABLE referral voucher (data/airtime) to the user's phone. */
export function useClaimReferralReward() {
  const qc = useQueryClient();
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;

  return useMutation<APIResponse<ClaimRewardResult>, APIError, string>(
    (grantId: string) =>
      post(
        `${API_URL}/user/account/referrals/rewards/${grantId}/claim`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      ),
    {
      onSuccess: () => {
        qc.invalidateQueries(["referral-rewards"]);
        qc.invalidateQueries(["referral-summary"]);
      },
    }
  );
}
